<template>
  <div>
    <!-- 在线阅卷确认弹窗 -->
    <van-popup 
      v-model="dialogVisible" 
      position="center"
      :style="{ borderRadius: '16px', overflow: 'hidden' }"
      :close-on-click-overlay="false"
      :lock-scroll="true"
    >
      <div class="review-dialog" @touchmove.stop>
        <div class="dialog-content">
          <div class="dialog-description">
            依照《中华人民共和国行政复议法》第四十七条的规定，经行政复议机构同意，现将被申请人提交的书面答复、证据、依据等有关材料供你查阅:
          </div>
        </div>
        <div class="dialog-footer">
          <van-button class="dialog-btn cancel-btn" @click="onCancel">取消</van-button>
          <van-button class="dialog-btn confirm-btn" @click="onConfirm">确定</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 签名弹窗 -->
    <mobile-sign-dialog
      v-if="signShow"
      ref="signDialog"
      :detail-info="detailInfo"
      :porp_signatureName="porp_signatureName"
      sign-type="onlineReview"
      :opera="0"
      @signature-submit="onSignatureSubmit"
    />
  </div>
</template>

<script>
import MobileSignDialog from '@/components/mobileSignDialog/mobileSignDialog.vue'
import { Toast } from 'vant'

export default {
  name: 'OnlineReview',
  components: {
    MobileSignDialog
  },
  props: {
    caseOrderNo: {
      type: String,
      default: ''
    },
    signatureName: {
      type: String,
      default: ''
    },
    detailInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      signShow: false,
      porp_signatureName: ''
    }
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true
    },
    
    // 取消按钮
    onCancel() {
      this.dialogVisible = false
    },
    
    // 确定按钮 - 打开签名弹窗
    onConfirm() {
      // 验证签名人姓名
      const signatureName = this.signatureName || 
                           (this.detailInfo && this.detailInfo.caseInfo && this.detailInfo.caseInfo.applicantName) ||
                           JSON.parse(localStorage.getItem('applicantInfo') || '{}').loginName || ''
      this.porp_signatureName = signatureName
      if (!signatureName) {
        signatureName = ''
      }
      
      // 关闭当前弹窗
      this.dialogVisible = false
      
      // 延迟显示签名组件
      setTimeout(() => {
        this.signShow = true
        this.$nextTick(() => {
          if (this.$refs.signDialog) {
            this.$refs.signDialog.open()
          }
        })
      }, 100)
    },
    
    // 签名提交完成
    onSignatureSubmit(data) {
      console.log('在线阅卷签名完成', data)
      this.signShow = false
      
      // 触发确认事件
      this.$emit('confirm', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.review-dialog {
  width: 680px;
  max-width: 90vw;
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
}

.dialog-content {
  padding: 30px 20px 20px;
}

.dialog-description {
  font-size: 14px;
  color: #666;
  line-height: 24px;
  margin-bottom: 20px;
  text-align: left;
}

.dialog-footer {
  display: flex;
  padding: 10px 20px 20px;
  gap: 15px;
}

.dialog-btn {
  flex: 1;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 6px;
}

.cancel-btn {
  color: #666;
  background-color: #fff;
  border: 1px solid #666;
}

.confirm-btn {
  color: #fff;
  background-color: #2D7DFB;
  border: none;
}
</style>

